/** @format */

import React from 'react';
import { Col, Row } from 'antd';
import { SpouseInfo } from '../types';

interface SpouseFormProps {
  spouseInfo: SpouseInfo;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SpouseForm: React.FC<SpouseFormProps> = ({ spouseInfo, onChange }) => {
  return (
    <Col sm={24} md={24} lg={24} xl={24}>
      <Row gutter={[24, 24]}>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className='form-heading'>
            <span>Spouse Information</span>
          </div>
        </Col>

        <Col sm={24} md={12} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label style={{ marginBottom: '10px' }}>Spouse First Name *</label>
            <input
              type='text'
              name='spouseInfo.firstName'
              value={spouseInfo.firstName}
              onChange={onChange}
              required
            />
          </div>
        </Col>

        <Col sm={24} md={12} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label style={{ marginBottom: '10px' }}>Spouse Last Name *</label>
            <input
              type='text'
              name='spouseInfo.lastName'
              value={spouseInfo.lastName}
              onChange={onChange}
              required
            />
          </div>
        </Col>

        <Col sm={24} md={12} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label>Spouse Date of Birth *</label>
            <input
              type='date'
              name='spouseInfo.dob'
              value={spouseInfo.dob}
              onChange={onChange}
              required
            />
          </div>
        </Col>

        <Col sm={24} md={12} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label>Spouse SSN *</label>
            <input
              type='text'
              name='spouseInfo.ssn'
              value={spouseInfo.ssn}
              onChange={onChange}
              required
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};
